import { ArrowUpRight } from 'lucide-react';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';

export const HighBadge: FC = () => {
  const { t } = useTranslation(['component']);
  return (
    <Badge className="border-transparent bg-warning text-white">
      {t('component:badge.high')}
      <ArrowUpRight aria-hidden className="size-3 shrink-0" />
    </Badge>
  );
};
